import {XauditModel} from '../xaudit.model';
import {PatientInsuranceCoverageDataModel} from '../patient/patient-insurance-coverage-data.model';
import {ConfigInsurancePayerIdModel} from './config-insurance-payer-id.model';
import {OrganizationDataModel} from '../organization/organization-data.model';

export class InsuranceDataModel extends XauditModel {
  Description: string;
  EmployerNO: string;
  GroupNO: string;
  InsuranceID: string;
  OrganizationID: string;
  PayerID: string;
  TDOIC: number;
  dataOrganization: OrganizationDataModel;
  dataOrganizations: OrganizationDataModel[];
  cfgInsurancePayerID: ConfigInsurancePayerIdModel;
  cfgInsurancePayerIDs: ConfigInsurancePayerIdModel[];
  dataPatientInsuranceCoverages: PatientInsuranceCoverageDataModel[];
  FeeScheduleID: string;
}
